// src/finance/FinanceLayout.tsx
import { Outlet } from 'react-router-dom'

export function FinanceLayout() {
  return <Outlet />
}
